// extracted by mini-css-extract-plugin
export var attachment = "_qd-a";
export var emailContainer = "_qd-4";
export var emailContentPaddedContainer = "_qd-b";
export var emailHeader = "_qd-6";
export var emailIframe = "_qd-3";
export var emailInfoIcon = "_qd-9";
export var emailShortenedSummary = "_qd-e";
export var infoDropdown = "_qd-0";
export var infoRowBoundedContent = "_qd-d";
export var internal = "_qd-5";
export var merchant = "_qd-8";
export var messageInputContainer = "_qd-h";
export var normal = "_qd-7";
export var replyCard = "_qd-f";
export var subtleButton = "_qd-1";
export var subtleButtonIconContainer = "_qd-2";
export var toggleViewRepliesButton = "_qd-c";
export var wrappingText = "_qd-g";